import strings from "./Error.strings";
import { useStrings } from "features/i18n/useStrings";
import "./Error.less";

export default function Error({ code }: { code: "403" | "404" }) {
    const t = useStrings(strings);
    return (
        <div className="ErrorMessage">
            <h2>{t[code]}</h2>
        </div>
    );
}
